module.exports = __webpack_public_path__ + "img/p6-p1-yanzi.861ae85a.png";